module.exports = __webpack_public_path__ + "static/media/1009380.1abf819a.png";